import { createContext, useContext } from "react";

export const LangContext = createContext({ lang: "pt", setLang: () => {} });
export const useLang = () => useContext(LangContext);

export const LANGS = [
  { id: "pt", label: "PT" },
  { id: "en", label: "EN" },
  { id: "es", label: "ES" },
];

export const STR = {
  pt: {
    nav_manifesto: "Manifesto",
    nav_vip: "Acesso VIP",
    nav_faq: "FAQ",
    download_app: "Baixar app",
    hero_pill: "+12.400 partidas jogadas hoje",
    hero_l1: "O clássico",
    hero_l2: "jogo da velha.",
    hero_l3: "Valendo de verdade.",
    hero_sub:
      "Jogo da velha, par ou ímpar, pedra papel tesoura e forca contra amigos ou contra a IA — grátis ou no modo competitivo, apostando créditos. O vencedor leva o pote na hora.",
    hero_tagline: "Jogue. Desafie. Vença.",
    dl_apple: "Baixar na",
    dl_google: "Disponível no",
    stat_60s: "por partida",
    stat_pix: "troque por produtos",
    stat_age: "jogo responsável",
    tab_velha: "Jogo da Velha",
    tab_parimpar: "Par ou Ímpar",
    you: "Você",
    wins: "vitórias",
    credits_word: "créditos",
    st_your_turn: "Sua vez — você é o X",
    st_thinking: "IA pensando...",
    st_win: "Você venceu! +10 créditos",
    st_lose: "A IA venceu desta vez",
    st_draw: "Empate — créditos devolvidos",
    in_dispute: "Em disputa",
    credits10: "10 créditos",
    match: "Partida",
    s60: "60 segundos",
    pi_choose: "Escolha par ou ímpar",
    pi_side: "Escolha seu lado",
    pi_par: "PAR",
    pi_impar: "ÍMPAR",
    pi_you_par: "Você é PAR — mostre os dedos",
    pi_you_impar: "Você é ÍMPAR — mostre os dedos",
    pi_fingers: "Quantos dedos você mostra?",
    pi_ai_took: "A IA levou esta",
    pi_round: "Rodada",
    pi_flash: "relâmpago",
    marquee: [
      "JOGUE", "DESAFIE", "VENÇA", "X vs O", "PAR OU ÍMPAR", "TROQUE POR PRÊMIOS",
      "RANKING NACIONAL", "DISPUTAS SEGURAS", "PRÊMIOS REAIS", "IA TREINADORA", "100% TRANSPARENTE",
    ],
    man_eyebrow: "Manifesto DUELO",
    man_h2a: "Simples de jogar.",
    man_h2b: "Impossível de largar.",
    f1_title: "Quatro jogos clássicos",
    f1_tag: "VELHA · PAR OU ÍMPAR · JOKENPÔ · FORCA",
    f1_desc:
      "Jogo da velha, par ou ímpar, pedra papel tesoura e forca contra amigos online ou contra a IA. Regras que todo mundo conhece — agora valendo de verdade.",
    f2_title: "Aposte créditos",
    f2_tag: "MODO COMPETITIVO",
    f2_desc:
      "Coloque créditos na mesa em partidas rápidas de 60 segundos. Empate devolve, vitória leva o pote — na hora.",
    f3_title: "Carteira transparente",
    f3_tag: "CARTEIRA & LOJA",
    f3_desc:
      "Seus créditos acumulados viram produtos reais na loja do DUELO. Cada crédito tem origem rastreada: depositou, ganhou ou trocou — tudo transparente.",
    f4_title: "Ranking nacional",
    f4_tag: "RECOMPENSAS SEMANAIS",
    f4_desc:
      "Escale a liga dos mestres do jogo da velha. Os melhores da semana dividem prêmios bônus e troféus digitais.",
    prev_eyebrow: "Dentro do DUELO",
    prev_h2a: "Uma arena",
    prev_h2b: "no seu bolso",
    prev_sub:
      "Partidas relâmpago, carteira transparente e uma loja de recompensas para trocar créditos por produtos, além de um ranking nacional que premia os melhores toda semana.",
    tab_match: "Partida",
    tab_wallet: "Carteira",
    tab_ranking: "Ranking",
    scr_turn: "Seu turno",
    scr_wallet: "Minha carteira",
    scr_total: "Saldo total",
    scr_dep: "Depositado",
    scr_profit: "Lucro",
    scr_fee: "Créditos acumulados",
    scr_receive: "Disponível p/ trocas",
    scr_withdraw: "Trocar por produtos",
    scr_rank: "Ranking nacional",
    scr_weekly: "Semanal",
    scr_wins: "vitórias",
    scr_top3: "Top 3 divide o prêmio bônus",
    rew_eyebrow: "Loja de recompensas",
    rew_h2a: "Vença duelos. Acumule créditos.",
    rew_h2b: "Troque por produtos.",
    rew_sub:
      "Cada vitória soma créditos na sua carteira. Troque direto na loja do DUELO por gift cards, eletrônicos e prêmios exclusivos — sem pressa, no seu ritmo.",
    rew_progress: "Seu progresso",
    rew_note: "Catálogo ilustrativo do lançamento — novos prêmios toda temporada",
    r1_name: "Gift card R$ 50",
    r2_name: "Fone Bluetooth",
    r3_name: "Smartphone novo",
    r1_price: "8.000 créditos",
    r2_price: "24.000 créditos",
    r3_price: "120.000 créditos",
    vip_badge: "Bônus de lançamento",
    vip_h2a: "Garanta",
    vip_h2b: "200 créditos",
    vip_h2c: "no lançamento",
    vip_sub:
      "Cadastre seu e-mail para entrar na lista de acesso antecipado do DUELO e receba um passe VIP exclusivo.",
    vip_submit: "Garantir acesso VIP + bônus",
    vip_both: "Ambos",
    vip_ok_t: "Você está dentro!",
    vip_ok_s:
      "Avisaremos por e-mail assim que o DUELO abrir as portas — seu bônus de 200 créditos já está reservado.",
    vip_counter: "jogadores já cadastrados",
    toast_ok: "Acesso VIP garantido! Nos vemos no tabuleiro.",
    toast_dup: "Você já estava na lista VIP!",
    toast_err: "Algo deu errado. Tente novamente.",
    cta_h2a: "Pronto para dominar",
    cta_h2b: "o tabuleiro?",
    cta_sub:
      "Em breve para iOS e Android. Entre na fila oficial e seja um dos primeiros a duelar valendo créditos.",
    badge_soon: "Em breve",
    badge_beta: "Beta aberto",
    qr_title: "Direto no celular",
    qr_sub: "Aponte a câmera do celular e entre na arena em segundos.",
    cta_toast: "{store}: cadastre-se na lista VIP acima para ser avisado no lançamento.",
    cd_label: "Lançamento oficial em",
    cd_d: "dias",
    cd_h: "horas",
    cd_m: "min",
    cd_s: "seg",
    cd_sub: "O app chega primeiro para quem está na lista VIP.",
    faq_eyebrow: "Dúvidas frequentes",
    faq_h2: "Perguntas & respostas",
    faq_items: [
      {
        q: "O que são os créditos do DUELO?",
        a: "Créditos são a moeda do app: você os usa para entrar em duelos valendo prêmio. Cada crédito tem um valor definido pela plataforma e todo o histórico fica registrado na sua carteira.",
      },
      {
        q: "Como funciona um duelo valendo créditos?",
        a: "Você desafia um jogador online, escolhe o valor da partida e o adversário aceita com o mesmo valor. Os créditos ficam bloqueados até o fim: o vencedor leva o pote e, em caso de empate, cada um recebe seus créditos de volta.",
      },
      {
        q: "Como acumulo créditos e troco por produtos?",
        a: "Cada duelo vencido soma créditos na sua carteira. Na loja do DUELO você troca o saldo por gift cards, eletrônicos e prêmios exclusivos — e o progresso de cada produto aparece na sua tela.",
      },
      {
        q: "Posso sacar os créditos em dinheiro?",
        a: "Não. Os créditos do DUELO não são convertidos em dinheiro: eles entram em duelos e são trocados por produtos na loja — iPhones, consoles, eletrodomésticos e muito mais. Simples assim.",
      },
      {
        q: "Posso jogar de graça?",
        a: "Sim. O modo gratuito é completo: partidas contra outros jogadores ou contra a IA, ranking, amigos e estatísticas — sem colocar nenhum crédito em disputa.",
      },
      {
        q: "O DUELO é seguro?",
        a: "O resultado de cada partida é decidido pelo servidor, nunca pelo celular. Temos sistema antifraude, registros imutáveis de partidas e transações, verificação de idade (+18) e avisos de jogo responsável.",
      },
      {
        q: "Como recebo o produto que troquei?",
        a: "Após a troca, o produto é enviado para o endereço cadastrado em até 2 dias úteis, com código de rastreio no app. O prazo médio de entrega é de 5 a 12 dias úteis, conforme sua região.",
      },
      {
        q: "O DUELO entrega em todo o Brasil? Tem frete?",
        a: "Entregamos em todo o território nacional e o frete é por nossa conta. Regiões de difícil acesso podem ter prazo estendido, sempre informado antes de você confirmar a troca.",
      },
      {
        q: "Posso jogar pelo site?",
        a: "Não — o site é apenas uma vitrine com demonstrações gratuitas. Para jogar valendo créditos, acumular e trocar por produtos, baixe o aplicativo DUELO para iOS ou Android.",
      },
    ],
    fl1: "Termos de uso",
    fl2: "Privacidade",
    fl3: "Jogo responsável",
    fl4: "Suporte 24/7",
    age: "+18 · Jogo responsável",
    copy: "© 2026 DUELO. Todos os direitos reservados.",
    footer_tag: "Jogue. Desafie. Vença.",
    hiw_eyebrow: "Como funciona",
    hiw_h2a: "Comprou, jogou,",
    hiw_h2b: "trocou.",
    hiw_sub:
      "Pix só na entrada — para comprar créditos. Na saída, só produtos: você nunca saca dinheiro, você troca por prêmios.",
    hiw_s1t: "Compre créditos",
    hiw_s1d: "Recarga instantânea via Pix. O valor do crédito aparece antes da compra, sem surpresas.",
    hiw_s2t: "Vença duelos",
    hiw_s2d: "Jogo da velha ou par ou ímpar contra jogadores reais ou IA. Cada vitória soma créditos na carteira.",
    hiw_s3t: "Acompanhe o progresso",
    hiw_s3d: "Cada produto da loja mostra quanto falta: a barra enche a cada vitória.",
    hiw_s4t: "Troque por produtos",
    hiw_s4d: "Atingiu a meta? Troque na hora e receba em casa com rastreio.",
    win_eyebrow: "Vitrine de ganhadores",
    win_h2a: "Quem joga,",
    win_h2b: "leva.",
    win_sub: "Jogadores do beta que já trocaram créditos por prêmios de verdade.",
    win_note: "Histórias ilustrativas do programa beta",
    win_got: "trocou por",
    tab_rps: "Jokenpô",
    tab_candy: "Candy Match",
    candy_turn_you: "Sua vez — troque 2 doces vizinhos",
    candy_turn_ai: "Vez da IA…",
    candy_invalid: "Jogada inválida — forme 3 ou mais",
    candy_moves: "jogadas",
    candy_again: "Jogar de novo",
    rps_choose: "Pedra, papel ou tesoura?",
    rps_pedra: "Pedra",
    rps_papel: "Papel",
    rps_tesoura: "Tesoura",
    tor_tag: "MODO TORNEIO",
    tor_title: "Torneio Jokenpô",
    tor_desc:
      "Chaveamento mata-mata com 8 jogadores de pedra papel tesoura. O campeão leva prêmio extra em créditos — além do pote de cada rodada.",
    tor_qf: "Quartas",
    tor_sf: "Semis",
    tor_f: "Final",
    tor_extra: "Prêmio extra do campeão",
    gs_label: "Placar global",
    gs_you: "Visitantes",
    gs_ai: "IA",
    snd_toggle: "Ativar ou silenciar sons",
  },
  en: {
    nav_manifesto: "Manifesto",
    nav_vip: "VIP Access",
    nav_faq: "FAQ",
    download_app: "Get the app",
    hero_pill: "+12,400 matches played today",
    hero_l1: "The classic",
    hero_l2: "tic-tac-toe.",
    hero_l3: "Now for real.",
    hero_sub:
      "Tic-tac-toe, odds & evens, rock paper scissors and hangman against friends or the AI — free or in competitive mode, staking credits. The winner takes the pot instantly.",
    hero_tagline: "Play. Challenge. Win.",
    dl_apple: "Download on the",
    dl_google: "Get it on",
    stat_60s: "per match",
    stat_pix: "redeem for products",
    stat_age: "responsible play",
    tab_velha: "Tic Tac Toe",
    tab_parimpar: "Odds & Evens",
    you: "You",
    wins: "wins",
    credits_word: "credits",
    st_your_turn: "Your turn — you are X",
    st_thinking: "AI is thinking...",
    st_win: "You won! +10 credits",
    st_lose: "The AI wins this one",
    st_draw: "Draw — credits returned",
    in_dispute: "At stake",
    credits10: "10 credits",
    match: "Match",
    s60: "60 seconds",
    pi_choose: "Pick odds or evens",
    pi_side: "Choose your side",
    pi_par: "EVEN",
    pi_impar: "ODD",
    pi_you_par: "You are EVEN — show your fingers",
    pi_you_impar: "You are ODD — show your fingers",
    pi_fingers: "How many fingers do you show?",
    pi_ai_took: "The AI takes this one",
    pi_round: "Lightning",
    pi_flash: "round",
    marquee: [
      "PLAY", "CHALLENGE", "WIN", "X vs O", "ODDS OR EVENS", "REDEEM FOR PRIZES",
      "NATIONAL RANKING", "SECURE DUELS", "REAL PRIZES", "AI COACH", "100% TRANSPARENT",
    ],
    man_eyebrow: "DUELO Manifesto",
    man_h2a: "Easy to play.",
    man_h2b: "Impossible to put down.",
    f1_title: "Four classic games",
    f1_tag: "TIC-TAC-TOE · ODDS/EVENS · RPS · HANGMAN",
    f1_desc:
      "Tic-tac-toe, odds & evens, rock paper scissors and hangman against friends online or the AI. Rules everyone knows — now played for real stakes.",
    f2_title: "Stake credits",
    f2_tag: "COMPETITIVE MODE",
    f2_desc:
      "Put your credits on the line in 60-second matches. A draw refunds, a win takes the pot — instantly.",
    f3_title: "Transparent wallet",
    f3_tag: "WALLET & STORE",
    f3_desc:
      "Your stacked credits become real products in the DUELO store. Every credit is tracked: deposited, won or redeemed — fully transparent.",
    f4_title: "National ranking",
    f4_tag: "WEEKLY REWARDS",
    f4_desc:
      "Climb the national league of tic-tac-toe masters. The week's best players split bonus prizes and digital trophies.",
    prev_eyebrow: "Inside DUELO",
    prev_h2a: "An arena",
    prev_h2b: "in your pocket",
    prev_sub:
      "Lightning matches, a transparent wallet and a rewards store to redeem credits for products, plus a national ranking that rewards the best every week.",
    tab_match: "Match",
    tab_wallet: "Wallet",
    tab_ranking: "Ranking",
    scr_turn: "Your turn",
    scr_wallet: "My wallet",
    scr_total: "Total balance",
    scr_dep: "Deposited",
    scr_profit: "Profit",
    scr_fee: "Stacked credits",
    scr_receive: "Available to redeem",
    scr_withdraw: "Redeem products",
    scr_rank: "National ranking",
    scr_weekly: "Weekly",
    scr_wins: "wins",
    scr_top3: "Top 3 splits the bonus prize",
    rew_eyebrow: "Rewards store",
    rew_h2a: "Win duels. Stack credits.",
    rew_h2b: "Redeem for products.",
    rew_sub:
      "Every win adds credits to your wallet. Redeem directly in the DUELO store for gift cards, electronics and exclusive prizes — at your own pace.",
    rew_progress: "Your progress",
    rew_note: "Illustrative launch catalog — new prizes every season",
    r1_name: "Gift card R$ 50",
    r2_name: "Bluetooth headphones",
    r3_name: "New smartphone",
    r1_price: "8,000 credits",
    r2_price: "24,000 credits",
    r3_price: "120,000 credits",
    vip_badge: "Launch bonus",
    vip_h2a: "Get",
    vip_h2b: "200 credits",
    vip_h2c: "at launch",
    vip_sub:
      "Register your email to join DUELO's early-access list and receive an exclusive VIP pass.",
    vip_submit: "Claim VIP access + bonus",
    vip_both: "Both",
    vip_ok_t: "You're in!",
    vip_ok_s:
      "We'll email you as soon as DUELO opens its doors — your 200-credit bonus is already reserved.",
    vip_counter: "players already registered",
    toast_ok: "VIP access secured! See you on the board.",
    toast_dup: "You were already on the VIP list!",
    toast_err: "Something went wrong. Please try again.",
    cta_h2a: "Ready to rule",
    cta_h2b: "the board?",
    cta_sub:
      "Coming soon to iOS and Android. Join the official queue and be among the first to duel for credits.",
    badge_soon: "Coming soon",
    badge_beta: "Open beta",
    qr_title: "Straight to your phone",
    qr_sub: "Point your phone's camera and jump into the arena in seconds.",
    cta_toast: "{store}: join the VIP list above to be notified at launch.",
    cd_label: "Official launch in",
    cd_d: "days",
    cd_h: "hours",
    cd_m: "min",
    cd_s: "sec",
    cd_sub: "The app arrives first for those on the VIP list.",
    faq_eyebrow: "Frequently asked questions",
    faq_h2: "Questions & answers",
    faq_items: [
      {
        q: "What are DUELO credits?",
        a: "Credits are the app's currency: you use them to enter prize duels. Each credit has a value set by the platform and your full history is recorded in your wallet.",
      },
      {
        q: "How does a credit duel work?",
        a: "You challenge an online player, pick the match value and the opponent accepts with the same amount. Credits stay locked until the end: the winner takes the pot and, on a draw, each player gets their credits back.",
      },
      {
        q: "How do I stack credits and redeem products?",
        a: "Every duel you win adds credits to your wallet. In the DUELO store you redeem your balance for gift cards, electronics and exclusive prizes — each product shows your progress.",
      },
      {
        q: "Can I withdraw credits as cash?",
        a: "No. DUELO credits are never converted into cash: they enter duels and are redeemed for products in the store — iPhones, consoles, home appliances and more. Simple as that.",
      },
      {
        q: "Can I play for free?",
        a: "Yes. Free mode is complete: matches against other players or the AI, ranking, friends and stats — without staking any credits.",
      },
      {
        q: "Is DUELO safe?",
        a: "Every match result is decided by the server, never by the phone. We have an anti-fraud system, immutable match and transaction records, age verification (+18) and responsible-play notices.",
      },
      {
        q: "How do I receive my redeemed product?",
        a: "After redeeming, the product ships to your registered address within 2 business days, with a tracking code in the app. Average delivery is 5–12 business days depending on your region.",
      },
      {
        q: "Does DUELO ship nationwide? Is shipping free?",
        a: "We ship across all of Brazil and shipping is on us. Remote areas may have extended delivery times, always shown before you confirm the redemption.",
      },
      {
        q: "Can I play on the website?",
        a: "No — the website is just a showcase with free demos. To play for credits, stack them and redeem products, download the DUELO app for iOS or Android.",
      },
    ],
    fl1: "Terms of use",
    fl2: "Privacy",
    fl3: "Responsible play",
    fl4: "24/7 support",
    age: "+18 · Responsible play",
    copy: "© 2026 DUELO. All rights reserved.",
    footer_tag: "Play. Challenge. Win.",
    hiw_eyebrow: "How it works",
    hiw_h2a: "Buy. Win.",
    hiw_h2b: "Redeem.",
    hiw_sub:
      "Pix is entry-only — used to buy credits. On the way out, it's products only: you never withdraw cash, you redeem prizes.",
    hiw_s1t: "Buy credits",
    hiw_s1d: "Instant top-up via Pix. The credit value is shown before purchase, no surprises.",
    hiw_s2t: "Win duels",
    hiw_s2d: "Tic-tac-toe or odds & evens against real players or the AI. Every win stacks credits in your wallet.",
    hiw_s3t: "Track your progress",
    hiw_s3d: "Every store product shows how close you are: the bar fills with each win.",
    hiw_s4t: "Redeem for products",
    hiw_s4d: "Hit the goal? Redeem instantly and get it delivered to your door with tracking.",
    win_eyebrow: "Winners showcase",
    win_h2a: "Play it.",
    win_h2b: "Win it.",
    win_sub: "Beta players who already redeemed credits for real prizes.",
    win_note: "Illustrative stories from the beta program",
    win_got: "redeemed",
    tab_rps: "Rock Paper Scissors",
    tab_candy: "Candy Match",
    candy_turn_you: "Your turn — swap 2 adjacent candies",
    candy_turn_ai: "AI's turn…",
    candy_invalid: "Invalid move — match 3 or more",
    candy_moves: "moves",
    candy_again: "Play again",
    rps_choose: "Rock, paper or scissors?",
    rps_pedra: "Rock",
    rps_papel: "Paper",
    rps_tesoura: "Scissors",
    tor_tag: "TOURNAMENT MODE",
    tor_title: "RPS Tournament",
    tor_desc:
      "8-player rock paper scissors knockout bracket. The champion takes an extra credit prize — on top of each round's pot.",
    tor_qf: "Quarterfinals",
    tor_sf: "Semis",
    tor_f: "Final",
    tor_extra: "Champion's extra prize",
    gs_label: "Global scoreboard",
    gs_you: "Visitors",
    gs_ai: "AI",
    snd_toggle: "Toggle sounds",
  },
  es: {
    nav_manifesto: "Manifiesto",
    nav_vip: "Acceso VIP",
    nav_faq: "FAQ",
    download_app: "Descargar app",
    hero_pill: "+12.400 partidas jugadas hoy",
    hero_l1: "El clásico",
    hero_l2: "tres en raya.",
    hero_l3: "Ahora en serio.",
    hero_sub:
      "Tres en raya, par o impar, piedra papel tijera y ahorcado contra amigos o contra la IA — gratis o en modo competitivo, apostando créditos. El ganador se lleva el pozo al instante.",
    hero_tagline: "Juega. Desafía. Gana.",
    dl_apple: "Descargar en",
    dl_google: "Disponible en",
    stat_60s: "por partida",
    stat_pix: "canjea por productos",
    stat_age: "juego responsable",
    tab_velha: "Tres en Raya",
    tab_parimpar: "Par o Impar",
    you: "Tú",
    wins: "victorias",
    credits_word: "créditos",
    st_your_turn: "Tu turno — eres la X",
    st_thinking: "IA pensando...",
    st_win: "¡Ganaste! +10 créditos",
    st_lose: "La IA gana esta vez",
    st_draw: "Empate — créditos devueltos",
    in_dispute: "En juego",
    credits10: "10 créditos",
    match: "Partida",
    s60: "60 segundos",
    pi_choose: "Elige par o impar",
    pi_side: "Elige tu lado",
    pi_par: "PAR",
    pi_impar: "IMPAR",
    pi_you_par: "Eres PAR — muestra los dedos",
    pi_you_impar: "Eres IMPAR — muestra los dedos",
    pi_fingers: "¿Cuántos dedos muestras?",
    pi_ai_took: "La IA se lleva esta",
    pi_round: "Ronda",
    pi_flash: "relámpago",
    marquee: [
      "JUEGA", "DESAFÍA", "GANA", "X vs O", "PAR O IMPAR", "CANJEA PREMIOS",
      "RANKING NACIONAL", "DUELOS SEGUROS", "PREMIOS REALES", "IA ENTRENADORA", "100% TRANSPARENTE",
    ],
    man_eyebrow: "Manifiesto DUELO",
    man_h2a: "Fácil de jugar.",
    man_h2b: "Imposible de soltar.",
    f1_title: "Cuatro juegos clásicos",
    f1_tag: "TRES EN RAYA · PAR/IMPAR · PPT · AHORCADO",
    f1_desc:
      "Tres en raya, par o impar, piedra papel tijera y ahorcado contra amigos en línea o contra la IA. Reglas que todos conocen — ahora valiendo de verdad.",
    f2_title: "Apuesta créditos",
    f2_tag: "MODO COMPETITIVO",
    f2_desc:
      "Pon tus créditos sobre la mesa en partidas rápidas de 60 segundos. El empate devuelve, la victoria se lleva el pozo — al instante.",
    f3_title: "Billetera transparente",
    f3_tag: "BILLETERA & TIENDA",
    f3_desc:
      "Tus créditos acumulados se convierten en productos reales en la tienda DUELO. Cada crédito tiene origen rastreado: depositaste, ganaste o canjeaste — todo transparente.",
    f4_title: "Ranking nacional",
    f4_tag: "RECOMPENSAS SEMANALES",
    f4_desc:
      "Escala la liga nacional de los maestros del tres en raya. Los mejores de la semana comparten premios bono y trofeos digitales.",
    prev_eyebrow: "Dentro de DUELO",
    prev_h2a: "Una arena",
    prev_h2b: "en tu bolsillo",
    prev_sub:
      "Partidas relámpago, billetera transparente y una tienda de recompensas para canjear créditos por productos, además de un ranking nacional que recompensa a los mejores cada semana.",
    tab_match: "Partida",
    tab_wallet: "Billetera",
    tab_ranking: "Ranking",
    scr_turn: "Tu turno",
    scr_wallet: "Mi billetera",
    scr_total: "Saldo total",
    scr_dep: "Depositado",
    scr_profit: "Ganancia",
    scr_fee: "Créditos acumulados",
    scr_receive: "Disponible p/ canjes",
    scr_withdraw: "Canjear productos",
    scr_rank: "Ranking nacional",
    scr_weekly: "Semanal",
    scr_wins: "victorias",
    scr_top3: "El top 3 comparte el premio bono",
    rew_eyebrow: "Tienda de recompensas",
    rew_h2a: "Gana duelos. Acumula créditos.",
    rew_h2b: "Cámbialos por productos.",
    rew_sub:
      "Cada victoria suma créditos en tu billetera. Canjéalos directo en la tienda DUELO por gift cards, electrónicos y premios exclusivos — a tu ritmo.",
    rew_progress: "Tu progreso",
    rew_note: "Catálogo ilustrativo del lanzamiento — nuevos premios cada temporada",
    r1_name: "Gift card R$ 50",
    r2_name: "Auriculares Bluetooth",
    r3_name: "Smartphone nuevo",
    r1_price: "8.000 créditos",
    r2_price: "24.000 créditos",
    r3_price: "120.000 créditos",
    vip_badge: "Bono de lanzamiento",
    vip_h2a: "Asegura",
    vip_h2b: "200 créditos",
    vip_h2c: "en el lanzamiento",
    vip_sub:
      "Registra tu correo para entrar en la lista de acceso anticipado de DUELO y recibe un pase VIP exclusivo.",
    vip_submit: "Asegurar acceso VIP + bono",
    vip_both: "Ambos",
    vip_ok_t: "¡Estás dentro!",
    vip_ok_s:
      "Te avisaremos por correo cuando DUELO abra sus puertas — tu bono de 200 créditos ya está reservado.",
    vip_counter: "jugadores ya registrados",
    toast_ok: "¡Acceso VIP asegurado! Nos vemos en el tablero.",
    toast_dup: "¡Ya estabas en la lista VIP!",
    toast_err: "Algo salió mal. Inténtalo de nuevo.",
    cta_h2a: "¿Listo para dominar",
    cta_h2b: "el tablero?",
    cta_sub:
      "Próximamente para iOS y Android. Entra en la fila oficial y sé de los primeros en duelar por créditos.",
    badge_soon: "Próximamente",
    badge_beta: "Beta abierta",
    qr_title: "Directo al celular",
    qr_sub: "Apunta la cámara de tu celular y entra en la arena en segundos.",
    cta_toast: "{store}: regístrate en la lista VIP para que te avisemos en el lanzamiento.",
    cd_label: "Lanzamiento oficial en",
    cd_d: "días",
    cd_h: "horas",
    cd_m: "min",
    cd_s: "seg",
    cd_sub: "La app llega primero para quienes están en la lista VIP.",
    faq_eyebrow: "Preguntas frecuentes",
    faq_h2: "Preguntas y respuestas",
    faq_items: [
      {
        q: "¿Qué son los créditos de DUELO?",
        a: "Los créditos son la moneda de la app: los usas para entrar en duelos con premio. Cada crédito tiene un valor definido por la plataforma y todo el historial queda registrado en tu billetera.",
      },
      {
        q: "¿Cómo funciona un duelo con créditos?",
        a: "Desafías a un jugador en línea, eliges el valor de la partida y el adversario acepta con el mismo valor. Los créditos quedan bloqueados hasta el final: el ganador se lleva el pozo y, en caso de empate, cada uno recupera sus créditos.",
      },
      {
        q: "¿Cómo acumulo créditos y los cambio por productos?",
        a: "Cada duelo ganado suma créditos en tu billetera. En la tienda de DUELO cambias tu saldo por gift cards, electrónicos y premios exclusivos — cada producto muestra tu progreso.",
      },
      {
        q: "¿Puedo retirar los créditos en dinero?",
        a: "No. Los créditos de DUELO no se convierten en dinero: entran en duelos y se canjean por productos en la tienda — iPhones, consolas, electrodomésticos y mucho más. Así de simple.",
      },
      {
        q: "¿Puedo jugar gratis?",
        a: "Sí. El modo gratuito es completo: partidas contra otros jugadores o contra la IA, ranking, amigos y estadísticas — sin poner ningún crédito en juego.",
      },
      {
        q: "¿DUELO es seguro?",
        a: "El resultado de cada partida lo decide el servidor, nunca el celular. Tenemos sistema antifraude, registros inmutables de partidas y transacciones, verificación de edad (+18) y avisos de juego responsable.",
      },
      {
        q: "¿Cómo recibo el producto que canjeé?",
        a: "Tras el canje, el producto se envía a la dirección registrada en hasta 2 días hábiles, con código de rastreo en la app. El plazo medio de entrega es de 5 a 12 días hábiles, según tu región.",
      },
      {
        q: "¿DUELO entrega en todo Brasil? ¿El envío es gratis?",
        a: "Entregamos en todo el territorio nacional y el envío corre por nuestra cuenta. Las regiones de difícil acceso pueden tener plazos extendidos, siempre informados antes de confirmar el canje.",
      },
      {
        q: "¿Puedo jugar en el sitio web?",
        a: "No — el sitio es solo una vitrina con demos gratuitas. Para jugar por créditos, acumularlos y canjear productos, descarga la app DUELO para iOS o Android.",
      },
    ],
    fl1: "Términos de uso",
    fl2: "Privacidad",
    fl3: "Juego responsable",
    fl4: "Soporte 24/7",
    age: "+18 · Juego responsable",
    copy: "© 2026 DUELO. Todos los derechos reservados.",
    footer_tag: "Juega. Desafía. Gana.",
    hiw_eyebrow: "Cómo funciona",
    hiw_h2a: "Compras, ganas,",
    hiw_h2b: "canjeas.",
    hiw_sub:
      "Pix solo en la entrada — para comprar créditos. A la salida, solo productos: nunca retiras dinero, canjeas premios.",
    hiw_s1t: "Compra créditos",
    hiw_s1d: "Recarga instantánea vía Pix. El valor del crédito se muestra antes de la compra, sin sorpresas.",
    hiw_s2t: "Gana duelos",
    hiw_s2d: "Tres en raya o par o impar contra jugadores reales o la IA. Cada victoria suma créditos en tu billetera.",
    hiw_s3t: "Sigue tu progreso",
    hiw_s3d: "Cada producto de la tienda muestra cuánto te falta: la barra se llena con cada victoria.",
    hiw_s4t: "Canjea por productos",
    hiw_s4d: "¿Llegaste a la meta? Canjea al instante y recíbelo en casa con rastreo.",
    win_eyebrow: "Vitrina de ganadores",
    win_h2a: "El que juega,",
    win_h2b: "se lo lleva.",
    win_sub: "Jugadores del beta que ya canjearon créditos por premios reales.",
    win_note: "Historias ilustrativas del programa beta",
    win_got: "canjeó",
    tab_rps: "Piedra Papel Tijera",
    tab_candy: "Candy Match",
    candy_turn_you: "Tu turno — intercambia 2 dulces vecinos",
    candy_turn_ai: "Turno de la IA…",
    candy_invalid: "Movimiento inválido — forma 3 o más",
    candy_moves: "jugadas",
    candy_again: "Jugar de nuevo",
    rps_choose: "¿Piedra, papel o tijera?",
    rps_pedra: "Piedra",
    rps_papel: "Papel",
    rps_tesoura: "Tijera",
    tor_tag: "MODO TORNEO",
    tor_title: "Torneo PPT",
    tor_desc:
      "Eliminatoria de 8 jugadores de piedra papel tijera. El campeón se lleva un premio extra en créditos — además del pozo de cada ronda.",
    tor_qf: "Cuartos",
    tor_sf: "Semis",
    tor_f: "Final",
    tor_extra: "Premio extra del campeón",
    gs_label: "Marcador global",
    gs_you: "Visitantes",
    gs_ai: "IA",
    snd_toggle: "Activar o silenciar sonidos",
  },
};
